module.exports = __webpack_public_path__ + "img/svg/background-reminder-deposit-modal.774a577edbbf763e8632082a6b6ad401.svg";